<template>
  <form v-if="!loading" @submit.prevent>
    <b-loading :is-full-page="false" :active.sync="cepLoading"></b-loading>

    <div class="row mb-2">
      <div class="col-12">
        <b-checkbox v-model="client.active" class="mr-4">Ativo</b-checkbox>
        <b-checkbox v-model="client.incomplete">Incompleto</b-checkbox>
        <b-checkbox v-model="client.ex_client">Ex Funcionário</b-checkbox>
        <b-checkbox v-model="client.firstaccessrelease">Liberar Primeiro Acesso</b-checkbox>
        <div class="points-badge">
          <h2>{{ client.points | number }}</h2>
          <p>pontos</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-6 col-xl-4">
        <app-input
          label="E-mail"
          v-model="client.email"
          :errors="errors.email"
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-3 col-xl-3">
        <b-field label="Senha">
          <b-input
            v-model="client.password"
            placeholder="Senha"
            type="password"
            password-reveal
          ></b-input>
        </b-field>
        <span class="error-alert" v-if="errors.password">{{
          errors.password[0]
        }}</span>
      </div>
      <div class="col-sm-6 col-lg-3 col-xl-3">
        <b-field label="Confirmar Senha">
          <b-input
            v-model="client.password_confirmation"
            placeholder="Confirmar Senha"
            type="password"
            password-reveal
          ></b-input>
        </b-field>
        <span class="error-alert" v-if="errors.password_confirmation">{{
          errors.password_confirmation[0]
        }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-lg-3">
        <app-autocomplete
          label="Rede"
          field="name"
          :searchFunction="searchNetworkFn"
          :resourceIdFunction="resourceNetworkFn"
          v-model="client.network_id"
          :errors="errors.network_id"
          required
        ></app-autocomplete>
      </div>
      <div class="col-sm-6 col-lg-3">
        <b-field label="Função" required>
          <b-select v-model="client.type" placeholder="Selecionar">
            <option
              v-for="type in typeOptions"
              :key="type[0]"
              :value="type[0]"
              >{{ type[1] }}</option
            >
          </b-select>
        </b-field>
        <span class="error-alert" v-if="errors.type">{{ errors.type[0] }}</span>
      </div>
      <div class="col-sm-6 col-lg-3">
        <app-input
          label="Nome"
          v-model="client.name"
          :errors="errors.name"
          required
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-3">
        <b-field label="Data de Nascimento">
          <b-datepicker
            v-model="client.birthdate"
            :date-formatter="bDateFormatter"
            :date-parser="dateParser"
            locale="pt-BR"
            editable
          ></b-datepicker>
        </b-field>
      </div>
      <div class="col-sm-6 col-lg-3">
        <app-input
          label="CPF"
          v-model="client.cpf"
          v-mask="'###.###.###-##'"
          :errors="errors.cpf"
          required
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-3">
        <app-input
          label="CNPJ Unidade"
          v-model="client.unit_cnpj"
          v-mask="'##.###.###/####-##'"
          :errors="errors.unit_cnpj"
          required
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Conta Mapipay"
          v-model="client.account"
          :errors="errors.account"
          maxlength="16"
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="Status Mapipay"
          v-model="client.account_status"
          :errors="errors.account_status"
          maxlength="16"
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3 col-lg-2">
        <div class="app-radio">
          <label>Sexo</label>
          <div class="app-radio__options">
            <b-radio v-model="client.sex" name="name" native-value="M"
              >Masculino</b-radio
            >
            <b-radio v-model="client.sex" name="name" native-value="F"
              >Feminino</b-radio
            >
          </div>

          <span class="error-alert" v-if="errors.sex">{{ errors.sex[0] }}</span>
        </div>
      </div>
      <div class="col-sm-4 col-lg-3 col-xl-2">
        <app-input
          label="Celular"
          v-model="client.cellphone"
          v-mask="'(##) #####-####'"
          :errors="errors.cellphone"
        ></app-input>
      </div>
      <div class="col-sm-4 col-lg-3 col-xl-2">
        <app-input
          label="Telefone"
          v-model="client.phone"
          v-mask="'(##) ####-####'"
          :errors="errors.phone"
        ></app-input>
      </div>

	<div class="col-sm-4">
		<b-field label="Tipo de Resgate">
			<div class="col-12">
			<b-checkbox v-model="client.is_able_mapipay" class="mr-4">Mapipay</b-checkbox>
			<b-checkbox v-model="client.is_able_mapiflex">Vale-Presente</b-checkbox>
			<b-checkbox v-model="client.is_able_britz">Britz</b-checkbox>
			</div>
		</b-field>
	</div>

      <div class="col-sm-6 col-lg-4 col-xl-3" Style='display:none'>
        <app-input
          label="Número Cartão"
          v-model="client.card_number"
          :errors="errors.card_number"
          maxlength="16"
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-4 col-xl-3" Style='display:none'>
        <app-input
          @change="validCard"
          label="Proxy Cartão"
          v-model="client.card_proxy"
          :errors="errors.card_proxy"
          maxlength="16"
        ></app-input>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <app-file-picker
          v-model="imageToCrop"
          label="Imagem"
          accept="image/*"
          flag="user_profile"
          @fileDeleted="onFileDeleted"
          required
        ></app-file-picker>

        <app-image-cropper
          v-if="imageToCrop"
          :src="imageToCrop"
          :aspectRatio="1"
          :stencil="'circle-stencil'"
          class="cropper-image"
          @croppedImage="onCropperImage"
        ></app-image-cropper>
      </div>

      <div v-if="client.picture" class="picture">
        <img :src="client.picture" alt="Imagem usuário" />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-3">
        <app-input
          label="CEP"
          v-model="client.address.postal_code"
          :errors="errors['address.postal_code']"
          @change="getCepInfo"
          maxlength="9"
          v-mask="'#####-###'"
        ></app-input>
      </div>
      <div class="col-sm-6">
        <app-input
          label="Rua"
          v-model="client.address.street"
          :errors="errors['address.street']"
        ></app-input>
      </div>
      <div class="col-sm-3">
        <app-input
          label="Número"
          v-model="client.address.number"
          :errors="errors['address.number']"
        ></app-input>
      </div>
      <div class="col-sm-3">
        <app-input
          label="Complemento"
          v-model="client.address.complement"
          :errors="errors['address.complement']"
        ></app-input>
      </div>
      <div class="col-sm-4">
        <app-input
          label="Bairro"
          v-model="client.address.neighborhood"
          :errors="errors['address.neighborhood']"
        ></app-input>
      </div>
      <div class="col-sm-4">
        <app-autocomplete
          label="Cidade"
          field="name_with_state"
          :searchFunction="searchCityFn"
          :resourceIdFunction="resourceCityFn"
          v-model="client.address.city_id"
          :errors="errors['address.city_id']"
        ></app-autocomplete>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button
          @click="onSubmit()"
          :disabled="$v.invalid || saving"
          type="submit"
          v-app-button
        >
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import CityService from '@/services/city.service';
import AddressService from '@/services/address.service';
import NetworkService from '@/services/network.service';
import ClientService from '@/services/client.service';
import ToastMixin from '@/mixins/ToastifyMixin';
import BuefyMixin from '@/mixins/BuefyMixin';
import AppImageCropper from '@/components/AppComponents/AppCropperImage.vue';
import ValidateCardService from '@/services/validate-card.service';
import { ClientTypeLabel } from '@/enums/ClientTypeEnum';
import { required, email, sameAs } from 'vuelidate/src/validators';
import * as moment from 'moment';

export default {
  name: 'clients-form',
  props: ['id', 'errors', 'saving'],
  mixins: [ToastMixin, BuefyMixin],
  components: { AppImageCropper },
  data: () => {
    return {
      loading: true,
      cepLoading: false,
      imageToCrop: null,
      typeOptions: Array.from(ClientTypeLabel),
      client: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        active: true,
        network_id: null,
        type: null,
        incomplete: true,
        cpf: null,
        unit_cnpj: null,
        birthdate: null,
        sex: null,
        cellphone: null,
        phone: null,
        ex_client: true,
        firstaccessrelease: false,
        card_number: null,
        card_proxy: null,
        picture: null,
        is_able_mapiflex: null,
        is_able_mapipay:null,
        is_able_britz:null,
        address: {
          street: null,
          postal_code: null,
          number: null,
          complement: null,
          neighborhood: null,
          city_id: null,
        },
      },
    };
  },
  validations() {
    return {
      client: {
        name: { required },
        email: { email },
        password_confirmation: { sameAsPassword: sameAs('password') },
        type: { required },
        cpf: { required },
        unit_cnpj: { required },
        network_id: { required },
      },
    };
  },
  methods: {
    loadClient(id) {
      ClientService.getId(id)
        .then(({ data: client }) => {
          this.client = {
            ...client,
            address: client.address || {},
            birthdate: client.birthdate ? new Date(client.birthdate) : null,
            is_able_mapiflex:client.is_able_mapiflex == 1 ? true: false,
            is_able_mapipay:client.is_able_mapipay == 1 ? true: false,
            is_able_britz:client.is_able_britz == 1 ? true: false,
          };
        })
        .catch(() => this.toastify('Erro ao carregar usuário.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.client,
        admin: true,
        birthdate:
          this.client.birthdate !== null
            ? moment(this.client.birthdate).format('DD/MM/YYYY')
            : '',
      });
    },
    onCropperImage(value) {
      this.client.picture = value;
      this.imageToCrop = '';
    },
    onFileDeleted() {
      this.client.picture = '';
    },
    validCard() {
      ValidateCardService.check(this.client.card_proxy, this.client.cpf)
        .then(({data}) => {
          this.toastify(data.message, data.success);
          this.client.card_proxy = data.success == "success" ? this.client.card_proxy : null;
        });
    },
    getCepInfo() {
      this.cepLoading = true;
      if (this.client.address.postal_code < 8) return;

      AddressService.cepInfo(this.client.address.postal_code)
        .then(({ data }) => {
          if (data === 422) {
            this.toastify('CEP Inválido', 'error');
            return;
          }
          this.client.address.street = data.logradouro;
          this.client.address.neighborhood = data.bairro;
          this.client.address.city_id = data.city_id;
        })
        .finally(() => (this.cepLoading = false));
    },
    dateParser(date) {
      try {
        return moment(date, 'DD/MM/YYYY').toDate();
      } catch (e) {
        return null;
      }
    },
    searchNetworkFn: NetworkService.search,
    resourceNetworkFn: NetworkService.getId,
    searchCityFn: CityService.search,
    resourceCityFn: CityService.getId,
  },
  beforeMount() {
    if (this.id) this.loadClient(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.picture-preview {
  max-height: 100px;
}

.message {
  font-style: italic;
  color: var(--color-danger);
  background: none;
}

.cropper-image {
  width: 600px;
}

.picture {
  height: 150px;
  width: 150px;
  border-radius: 50%;
  overflow: hidden;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.error-alert {
  font-size: 0.8em;
  color: #ff6363;
  position: relative;
  top: -16px;
}

.points-badge {
  min-width: 80px;
  padding: 8px 12px;
  padding-right: 24px;
  border-radius: 6px;
  float: right;
  background: var(--color-secondary);
  position: relative;
  box-shadow: 0px 2px 14px rgba(21, 23, 64, 0.03);

  h2,
  p {
    color: #fff;
    margin: 0;
  }

  h2 {
    font-weight: bold;
    font-size: 1.4em;
  }

  p {
    font-size: 0.9em;
  }

  &::after {
    content: '';
    background: var(--color-primary-shade);
    border-radius: 50%;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
